import React, { useState, useEffect, useContext, useRef } from 'react';
import SearchSightSeeingPanel from './SearhSightSeeingPanel';
import './Sightseeing.css';
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const useInView = (options) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) { setInView(true); observer.unobserve(entry.target); }
        }, options);
        if (ref.current) observer.observe(ref.current);
        return () => { if (ref.current) observer.unobserve(ref.current); };
    }, [ref, options]);
    return [ref, inView];
};

const SearchSightSeeing = () => {
    const landingData = useContext(LandingContext);
    const [offersRef, offersInView]             = useInView({ threshold: 0.1 });
    const [destinationsRef, destinationsInView] = useInView({ threshold: 0.1 });

    const sightseeingDeals = [
        {
            brand: 'City Tours',
            logoUrl: 'https://api.iconify.design/material-symbols/location-city.svg?color=%2310B981',
            title: 'Historic City Walks',
            description: 'Explore iconic landmarks with our expert-guided tours at unbeatable prices.',
            discount: 'Up to 20% OFF',
            type: 'percent',
        },
        {
            brand: 'Adventure',
            logoUrl: 'https://api.iconify.design/material-symbols/filter-hdr.svg?color=%232D93D3',
            title: 'Adrenaline Rush',
            description: 'Book thrilling activities — zip-lining, rafting, skydiving and more.',
            discount: 'Flat ₹2,000 OFF',
            type: 'flat',
        },
        {
            brand: 'Theme Parks',
            logoUrl: 'https://api.iconify.design/material-symbols/celebration.svg?color=%23C8A84B',
            title: 'Family Fun Day',
            description: 'Tickets to the most popular theme parks at family-friendly prices.',
            discount: 'From ₹1,999',
            type: 'price',
        },
    ];

    const popularActivities = [
        { name: 'Paris, France', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600' },
        { name: 'Rome, Italy',   image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=1996' },
        { name: 'Kyoto, Japan',  image: 'https://images.unsplash.com/photo-1528164344705-47542687000d?q=80&w=2070' },
        { name: 'Cairo, Egypt',  image: 'https://images.unsplash.com/photo-1539768942893-daf53e448371?w=600' },
    ];

    const heroStyle = {
        backgroundImage: landingData?.sightSeeingBackgroundSrc
            ? `url(${landingData.sightSeeingBackgroundSrc})`
            : 'url(/assets/images/sightseeing.jpg)',
    };

    return (
        <div className="main-content">
            {/* ── Hero ─────────────────────────────────── */}
            <section className="sightseeing-hero-section" style={heroStyle}>
                <h1 className="sightseeing-hero-title">Discover Amazing Activities</h1>
                <p className="sightseeing-hero-subtitle">Book sightseeing tours and experiences worldwide</p>
                <div className="sightseeing-search-container">
                    <SearchSightSeeingPanel />
                </div>
            </section>

            {/* ── Body ─────────────────────────────────── */}
            <div className="page-content" style={{ paddingTop: 0 }}>
                <div className="container py-5">

                    {/* Offers */}
                    <section ref={offersRef} className={`py-5 sightseeing-section-container${offersInView ? ' is-visible' : ''}`}>
                        <h2 className="section-title">Exclusive Activity Offers</h2>
                        <div className="row g-4">
                            {sightseeingDeals.map((deal, i) => (
                                <div className="col-lg-4 col-md-6" key={i}>
                                    <div className={`hotel-offer-card offer-card-${deal.type}`}>
                                        <div className="offer-card-header">
                                            <img src={deal.logoUrl} alt={deal.brand} className="airline-logo" />
                                            <span className="discount-badge">{deal.discount}</span>
                                        </div>
                                        <div className="offer-card-body">
                                            <h5 className="card-title">{deal.title}</h5>
                                            <p className="card-text">{deal.description}</p>
                                            <a href="#!" className="stretched-link">
                                                Book Now <i className="ri-arrow-right-line" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Popular activities */}
                    <section ref={destinationsRef} className={`py-5 sightseeing-section-container${destinationsInView ? ' is-visible' : ''}`}>
                        <h2 className="section-title">Top Activity Destinations</h2>
                        <div className="row g-4">
                            {popularActivities.map((dest, i) => (
                                <div className="col-lg-3 col-md-6" key={i}>
                                    <a href="#!" className="destination-card-modern">
                                        <img src={dest.image} alt={dest.name} className="card-img" />
                                        <div className="card-img-overlay">
                                            <h4 className="card-title">{dest.name}</h4>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default SearchSightSeeing;
